import config from "./config";
var axios = config();

export default {
  getContractStageCount() {
    return axios.get("/api/ContractReporting/GetContractStageCount", {
      params: {}
    });
  },

  getContractTimeAverages(agreementType) {
    return axios.get(
      "/api/ContractReporting/GetContractTimeAverages?agreementType=" +
        agreementType,
      { params: {} }
    );
  },

  getCompletedContracts() {
    return axios.get("/api/ContractReporting/GetCompletedContracts", {
      params: {}
    });
  },

  getExpiringContracts(expireAfterDate, expireByDate) {
    return axios.get("/api/ContractReporting/GetExpiringContracts", {
      params: { startDate: expireAfterDate, endDate: expireByDate }
    });
  }
};
